const worker = {
  run: (places: LocalisationResponse[]): Promise<LocationTreeItem[]> => {
    return new Promise((res) => {
      const webworker = new window.Worker('./tasks/location.tree.task.js')

      webworker.postMessage({ places })

      webworker.onmessage = (e) => {
        if (e.data) {
          res(e.data.result)
        }
      }
    })
  },
}

export default worker
